import { getAxiosClientWithToken } from "./index";

export const getInsuranceConfigApi = () => {
    return getAxiosClientWithToken().get("/insurance");
  };

export const updateInsuranceConfigApi = (body: any) => {
  return getAxiosClientWithToken().put(`/insurance`, body);
};